import { OverlayShellConfig } from "../../shared/overlay-shell/overlay.models";

export const EMPLOYEE_ACTIVATION_CHECKLIST_OVERLAY_CONFIG: OverlayShellConfig =
  {
    resizable: false,
    width: "auto",
    height: "auto",
  };
